function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06344C"
    },
    d: "M354.121,0H157.884c-19.705,0-35.68,15.974-35.68,35.68l133.798,22.756L389.8,35.68 C389.8,15.974,373.826,0,354.121,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06344C"
    },
    d: "M122.204,476.32c0,19.705,15.974,35.68,35.68,35.68h196.237c19.705,0,35.68-15.974,35.68-35.68 l-133.798-22.756L122.204,476.32z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 122.2,
    y: 35.68,
    style: {
      fill: "#0299D1"
    },
    width: 267.594,
    height: 440.639
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d628416324dc14e5d1c9e784a9fd4f97.svg";
export { ForwardRef as ReactComponent };